<ws-modal-wrapper (cancel)="cancel()"
                  (save)="save()"
                  [hideSave]="!result?.length"
                  acceptLabel="Save"
                  headerLabel="Add Tax Authorities">
    <ws-ag-grid-angular (gridReady)="onAgGridReady($event)"
                        [gridOptions]="gridOptions">
    </ws-ag-grid-angular>
</ws-modal-wrapper>
